import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../lib/api";

export default function StaticPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPage(null); setNotFound(false);
    api.get(`/pages/${slug}`).then(r => setPage(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="pt-28 min-h-screen flex items-center justify-center">
        <div className="text-center">
          <p className="overline mb-3">404</p>
          <h1 className="font-heading text-4xl text-ivory">Página no encontrada</h1>
        </div>
      </div>
    );
  }

  if (!page) {
    return <div className="pt-28 min-h-screen flex items-center justify-center"><div className="overline animate-pulse">Cargando...</div></div>;
  }

  return (
    <article data-testid="static-page" className="pt-28 min-h-screen">
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <p className="overline mb-4">M&H Lumora</p>
        <h1 className="font-heading text-5xl md:text-6xl text-ivory font-light tracking-tighter mb-12">{page.title}</h1>
        <div className="prose-luxe text-ivory text-base leading-relaxed whitespace-pre-wrap" style={{ fontWeight: 400 }}>
          {page.content}
        </div>
      </div>
    </article>
  );
}
